<header class="header-style1 menu_area-light">
    <div class="navbar-default border-bottom border-color-light-white">
        <div #myDiv class=" text-white w-100 p-1 m-0  overflow-hidden border-bottom border-color-light-white">
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-12 ">
                    <marquee behavior="scroll" direction="left" onmouseover="this.stop();" onmouseout="this.start();">
                        <span href="tel:18008918962" class="text-white cursor-pointer"
                              *ngFor="let news of newsData" (click)="goTo('news')">{{ news?.title + "  |  " }} </span>
                    </marquee>
                </div>
                <div class="col-lg-8 col-md-8 col-sm-12 text-white " style="font-size: 12px;padding-top: 5px;">
                    <a class="float-end text-white  rounded al fw-bold glowing-button "
                       routerLink="/enquiry">
                        <span class=""> <i
                            class="fa fa-envelope"></i> APPLY NOW</span></a>
                    <a class="float-end text-white fw-bold mx-1 underline" href="https://student.arni.in/"
                       target="_blank"><i class="fas fa-chalkboard-teacher"></i> STUDENT PANEL</a>
                    <a class="float-end text-white fw-bold mx-1 underline" href="https://admin.arni.in/"
                       target="_blank"><i class="fas fa-user-circle"></i> ADMIN PANEL</a>
                    <a class="float-end text-white fw-bold mx-1 underline" href="https://arni.in/2024/24Entranceex.aspx"
                       target="_blank"><i class="fa fa-user-graduate"></i> PHD Entrance Exam</a>
                    <a class="float-end text-white fw-bold mx-1 underline" routerLink="/enquiry"><i
                        class="fa fa-phone"></i>
                        ENQUIRY</a>
                    <!--<a class="float-end text-white fw-bold mx-1" routerLink="/blog"><i class="fa fa-book-bible"></i>
                        BLOG</a>-->
                    <a class="float-end text-white fw-bold mx-1 underline" routerLink="/news"><i
                        class="fa fa-newspaper"></i> NEWS</a>
                    <a class="float-end text-white fw-bold mx-1 underline" routerLink="/career"><i
                        class="fa fa-graduation-cap"></i> CAREER</a>
                    <a class="float-end text-white fw-bold mx-1 underline" routerLink="/photo-gallery"><i
                        class="fa fa-photo-film"></i> GALLERY</a>
                    <a class="float-end text-white fw-bold mx-1 underline" routerLink="/contact"><i
                        class="fa fa-address-book"></i> CONTACT</a>
                    <a class="float-end text-white fw-bold mx-1 underline" routerLink="/library"><i
                        class="fa fa-book"></i>
                        LIBRARY</a>
                    <a class="float-end text-white fw-bold mx-1 underline" routerLink="/conference"><i
                        class="fas fa-project-diagram"></i>
                        CONFERENCE</a>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-12 col-lg-12">
                    <div class="menu_area alt-font">
                        <nav class="navbar navbar-expand-lg navbar-light p-0">
                            <div class="navbar-header navbar-header-custom">
                                <a routerLink="/" class="navbar-brand">
                                    <img id="logo" src="assets/img/logos/logo-inner.png" alt="logo"/>
                                </a>
                            </div>
                            <div class="navbar-toggler bg-primary abc {{phoneViewMenuOpen?'menu-opened':''}}"
                                 (click)="phoneViewMenuOpen=!phoneViewMenuOpen"></div>

                            <ul class=" navbar-nav ms-auto display-block-desktop" id="nav">
                                <li><a href="javascript:void(0)">ABOUT US</a>
                                    <ul>
                                        <li class="active"><a href="javascript:void(0)">Why ARNI</a>
                                            <ul>
                                                <li><a routerLink="/about-us">About Arni</a></li>
                                                <li><a routerLink="/vision-and-mission">Vision & Mission</a></li>
                                                <li><a routerLink="/act-and-statutes">ACT & Statutes</a></li>
                                            </ul>
                                        </li>
                                        <li><a href="javascript:void(0)">Governance</a>
                                            <ul>
                                                <li><a routerLink="board-of-research">Board of Research</a></li>
                                                <li><a routerLink="/affiliation">Affiliations</a></li>
                                            </ul>
                                        </li>
                                        <li><a href="javascript:void(0)">Management's Talk</a>
                                            <ul>
                                                <li><a routerLink="/chancellor">Chancellor</a></li>
                                                <li><a routerLink="/vice-chancellor">Vice Chancellor</a></li>
                                                <li><a routerLink="/dean-academic">Pro Vice Chancellor</a></li>
                                                <li><a routerLink="/registrar">Registrar</a></li>
                                                <li><a routerLink="/deanrd">Dean R&D</a></li>
                                            </ul>
                                        </li>
                                        <li><a href="javascript:void(0)">University Committees</a>
                                            <ul>
                                                <li><a routerLink="/committees">All Committees</a></li>
                                                <li><a routerLink="/dsw">Dean Student Welfare</a></li>
                                                <li><a routerLink="/antiragg">Anti-Ragging</a></li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <a class="cursor-pointer">ACADEMICS</a>
                                    <ul class="megamenu d-block p-0 m-0 border-start border-color-secondary border-5"
                                        [ngClass]="{'hide': menuOpen}">
                                        <div class="row w-100 ">
                                            <div class="col-md-3 ">
                                                <div class="nav p-3">
                                                    <div class=" pt-3 w-100 ">
                                                        <h2 class="fs-6 w-100"><i
                                                            class="fa fa-institution text-secondary"></i> Our
                                                            Schools</h2>
                                                        <hr class="border-dashed border-1 border-secondary w-50 align-self-start"/>
                                                    </div>
                                                    <div class=" w-100 ">
                                                        <p *ngFor="let school of MenuDetail; let i = index"
                                                           class="w-100 text-start p-0 m-0 mt-1">
                                                            <!-- Check if school has a link -->
                                                            <a *ngIf="school.link; else noLink"
                                                               class="text-start  p-0 m-0 cursor-pointer underline"
                                                               style="font-size: 13px; font-family: 'Roboto', sans-serif;
  font-weight: 100;"
                                                               [class.active]="i === activeSchoolIndex"
                                                               [routerLink]="school.link"
                                                               (click)="closeMenuOnClick()">
                                                                {{ school.name }}
                                                            </a>

                                                            <!-- If no link, just use a clickable div -->
                                                            <ng-template #noLink>
                                                                <a class=" text-start mb-1 p-0 underline cursor-pointer mb-1 "
                                                                   [class.active]="i === activeSchoolIndex"
                                                                   (click)="setActiveSchool(i)"
                                                                   style="font-size: 13px; font-family: 'Roboto', sans-serif;
  font-weight: 100;">
                                                                    {{ school.name }}
                                                                </a>
                                                            </ng-template>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 border-start">
                                                <div *ngFor="let school of MenuDetail; let i = index">
                                                    <div class="list-group" *ngIf="i === activeSchoolIndex">
                                                        <div class="align-items-center gap-2">
                                                            <div
                                                                class="d-flex justify-content-center align-items-center w-100 px-0 mx-0 text-center">
                                                                <div
                                                                    *ngFor="let detail of school.schoolDetail; let j = index"
                                                                    class="d-flex align-items-center w-100 text-center">
                                                                    <a class=" text-decoration-underline cursor-pointer text-center mt-1"
                                                                       (click)="closeMenuOnClick()"
                                                                       [routerLink]="detail.link"
                                                                       style="text-wrap: nowrap;font-family: Arial, Helvetica,serif;">
                                                                        {{ detail.name }}
                                                                        <button *ngIf="detail.submenu"
                                                                                class="btn px-0 bg-transparent border-0 outline-0"
                                                                                (click)="toggleSubmenu(i, j)">
                                                                            <i [ngClass]="{'fa-chevron-up': submenuOpen[i]?.[j], 'fa-chevron-down': !submenuOpen[i]?.[j]}"
                                                                               class="fa"></i>
                                                                        </button>
                                                                    </a>

                                                                    <div *ngIf="submenuOpen[i]?.[j]"
                                                                         class="dropdown-menu show top-10 position-absolute"
                                                                         (mouseleave)="resetSubmenuOpenStatus()">
                                                                        <a *ngFor="let sub of detail.submenu"
                                                                           class=" underline"
                                                                           [routerLink]="sub.link"
                                                                           (click)="closeMenuOnClick()">{{ sub.name }}</a>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div *ngFor="let detail of school.schoolContent"
                                                                 class="ps-3 pt-1">
                                                                <div class="row">
                                                                    <div class="col-md-4">
                                                                        <img *ngIf="detail?.image"
                                                                             [src]="detail?.image"
                                                                             alt=""
                                                                             class="rounded border-primary border-3"
                                                                             style="width: 200px; height: 150px"/>
                                                                    </div>
                                                                    <div class="col-md-8">
                                                                        <p *ngIf="detail?.content"
                                                                           class="mt-3">{{ detail.content.slice(0, 225) }}</p>
                                                                    </div>
                                                                    <div class="col-md-12">
                                                                        <p *ngIf="detail?.content"
                                                                           class="m-0 p-0">{{ detail.content.slice(225, 900) }}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-3 m-0 p-0">
                                                <img src="assets/img/banner/mega_menu_img.png"
                                                     style="margin-left: 30px;border-radius: 0 10px 10px 0;"
                                                     class="w-100 h-100"/>
                                            </div>
                                        </div>
                                    </ul>
                                </li>
                                <li><a routerLink="#!">RESEARCH</a>
                                    <ul>
                                        <li><a routerLink="/research">Research</a></li>
                                        <li><a routerLink="!#">Research Policy</a></li>
                                        <li><a routerLink="research-unit">Research Unit</a></li>
                                        <li><a routerLink="!#">Project Unit</a></li>
                                        <li><a routerLink="!#">Other Services</a></li>
                                        <li><a routerLink="!#">BORS</a></li>
                                    </ul>
                                </li>
                                <li><a routerLink="#!">ADMISSION</a>
                                    <ul>
                                        <li><a routerLink="/admission-offices">Admission Offices</a></li>
                                        <li><a routerLink="/brouchure">Download Brochure</a></li>
                                        <li><a routerLink="/admission-form">Admission Form</a></li>
                                        <li><a routerLink="#!">Scholarship</a>
                                            <ul>
                                                <li><a routerLink="scholarship">Scholarship</a></li>
                                                <li><a
                                                    class="cursor-pointer"
                                                    (click)="goTo('https://docs.google.com/forms/d/e/1FAIpQLSdxxio3X-aZm2D7M2M496XC9lu7UrxszbwUTvhKd00eLaFWdg/viewform')">Scholarship
                                                    JKSSS</a></li>
                                            </ul>
                                        </li>
                                        <li><a routerLink="acedamic-calendar">Academic Calendar</a></li>
                                        <li><a href="security-discipline">Security & Discipline</a></li>
                                        <li><a routerLink="refund-policy">Refund Policy</a></li>
                                    </ul>
                                </li>
                                <li><a href="javascript:void(0)">LIFE@ARNI</a>
                                    <ul>
                                        <li><a href="javascript:void(0)">ARNI INFRASTRUCTURE</a>
                                            <ul>
                                                <li><a routerLink="hostel-infrastructure">Infrastructure</a></li>
                                                <li><a routerLink="mess">Mess Facilities</a></li>
                                                <li><a routerLink="cafeteria">Cafeteria</a></li>
                                                <li><a routerLink="hostel-gallery">Hostel Gallery</a></li>
                                            </ul>
                                        </li>
                                        <li><a href="javascript:void(0)">TRANSPORT</a>
                                            <ul>
                                                <li><a routerLink="bus-facility">Bus Facility</a></li>
                                            </ul>
                                        </li>
                                        <li><a href="javascript:void(0)">LIBRARY</a>
                                            <ul>
                                                <li><a routerLink="library">Library</a></li>
                                            </ul>
                                        </li>
                                        <li><a href="javascript:void(0)">GALLERY</a>
                                            <ul>
                                                <li><a routerLink="video-gallery">Video Gallery</a></li>
                                                <li><a routerLink="media-gallery">Media Gallery</a>
                                                </li>
                                                <li><a routerLink="photo-gallery">Photo Gallery</a></li>
                                            </ul>
                                        </li>
                                        <li><a href="javascript:void(0)">GREEN CAMPUS</a>
                                            <ul>
                                                <li><a routerLink="green-campus">Green Campus Policy</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <li><a routerLink="/extra-curricullar-activities">Extracurricular
                                            Activities</a>
                                        </li>
                                    </ul>
                                </li>
                                <li><a routerLink="#!">EXAMINATION</a>
                                    <ul>
                                        <li><a class="cursor-pointer" (click)="goTo('https://student.arniu.in/')">Student
                                            Login</a></li>
                                        <li><a class="cursor-pointer"
                                               (click)="goTo('https://arni.in/Student/Studentlogin')">Result</a>
                                        </li>
                                        <li><a routerLink="/circular-notice">Circular Notice</a></li>
                                        <li><a routerLink="datesheet">Datesheet</a></li>
                                        <li><a routerLink="online-education">Online Education</a></li>
                                        <li><a routerLink="online-exam">Online Exam</a></li>
                                    </ul>
                                </li>
                                <li><a href="javascript:void(0)">IQAC</a>
                                    <ul>
                                        <li><a routerLink="/iqac">IQAC</a></li>
                                        <li><a routerLink="/iqac-minutes">Minutes</a></li>
                                        <li><a routerLink="iqac">Feedback</a></li>
                                        <li><a routerLink="student-survey">Survey</a></li>
                                        <li><a routerLink="/initiative-reports">Initiative</a></li>
                                        <li><a routerLink="/induction-program">Induction</a></li>
                                        <li><a routerLink="/quality-mandates">Mandates</a></li>
                                        <li><a routerLink="/mooc">MOOC</a></li>
                                    </ul>
                                </li>
                                <li><a class="cursor-pointer"
                                       (click)="goTo('https://arni.in/2024/AdmHome.aspx')">Admin</a></li>
                                <li><a class="cursor-pointer"
                                       (click)="goTo('https://arni.in/2024/StuGR.aspx')">SGRC</a>
                                </li>
                            </ul>
                            <!-- end menu area -->
                            <!-- start menu area mobile view -->
                            <ul class="navbar-nav ms-auto d-lg-none d-md-none  {{phoneViewMenuOpen?  'open display-block-mobile d-sm-block' : ''}}"
                                id="nav_mobile"
                                style="display:{{phoneViewMenuOpen?'block':'none'}};">
                                <li class="{{aboutus ? 'active' : ''}}" (click)="aboutus=!aboutus">
                                    <a
                                        routerLink="#!">ABOUT US</a>
                                    <ul class="{{aboutus? 'open' : ''}}"
                                        style="display:{{aboutus?'block !important': 'none'}};"
                                        (click)="phoneViewMenuOpen=!phoneViewMenuOpen">
                                        <li class="active"><a href="javascript:void(0)" class="heading">Why ARNI</a>
                                        </li>
                                        <li><a routerLink="/about-us">About Arni</a></li>
                                        <li><a routerLink="/vision-and-mission">Vision & Mission</a></li>
                                        <li><a routerLink="/act-and-statutes">ACT & Statutes</a></li>
                                        <li><a href="javascript:void(0)" class="heading">Governance</a></li>
                                        <li><a routerLink="board-of-research">Board of Research</a></li>
                                        <li><a routerLink="/affiliation">Affiliations</a></li>
                                        <li><a href="javascript:void(0)" class="heading">Management's Talk</a>
                                        <li><a routerLink="/chancellor">Chancellor</a></li>
                                        <li><a routerLink="/vice-chancellor">Vice Chancellor</a></li>
                                        <li><a routerLink="/dean-academic">Pro Vice Chancellor</a></li>
                                        <li><a routerLink="/registrar">Registrar</a></li>
                                        <li><a routerLink="/deanrd">Dean R&D</a></li>
                                        <li><a href="javascript:void(0)" class="heading">University Committees</a></li>
                                        <li><a routerLink="/committees">All Committees</a></li>
                                        <li><a routerLink="/dsw">Dean Student Welfare</a></li>
                                        <li><a routerLink="/antiragg">Anti-Ragging</a></li>
                                    </ul>
                                </li>
                                <li class="{{academics ? 'active' : ''}}" (click)="academics=!academics">
                                    <a>ACADEMICS</a>
                                    <ul class="{{academics? 'open' : ''}}"
                                        style="display:{{academics?'block !important': 'none'}};"
                                        (click)="phoneViewMenuOpen=!phoneViewMenuOpen">
                                        <li><a routerLink="#!" class="heading">Arni School of
                                            Technology</a></li>
                                        <li><a routerLink="ast">About us</a></li>
                                        <li><a routerLink="ast-syllabus">Syllabus</a></li>
                                        <li><a routerLink="">Department</a></li>
                                        <li><a routerLink="ast-civil-engineering">Civil
                                            Engineering</a></li>
                                        <li><a routerLink="ast-mechanical-engineering">Mechanical
                                            Engineering</a></li>
                                        <li><a
                                            routerLink="ast-computer-science-engineering">Computer
                                            Science Engineering</a></li>
                                        <li><a
                                            routerLink="ast-computer-science-application">Computer
                                            Science & Application</a></li>
                                        <li><a routerLink="ast-ece-ee">ECE & EE</a></li>
                                        <li><a routerLink="ast-cyber-security">Cyber
                                            Security &
                                            AI</a></li>
                                        <!-- <li><a routerLink="#!">Event</a></li>
                                         <li><a routerLink="ast-labs">Labs</a></li>-->
                                        <li><a routerLink="ast-contactus">Contact us</a></li>

                                        <li><a routerLink="#!" class="heading">Arni School of
                                            Business Management &
                                            Commerce</a></li>
                                        <li><a routerLink="asbmc">About us</a></li>
                                        <li><a routerLink="asbmc-syllabus">Syllabus</a></li>
                                        <li><a routerLink="">Department</a></li>
                                        <li><a routerLink="asbmc-business-studies">BusinessStudies</a>
                                        </li>
                                        <li><a routerLink="asbmc-commerce">Commerce</a>
                                        </li>
                                        <li><a routerLink="asbmc-hospitality-management">Hospitality
                                            Management</a></li>
                                        <!--<li><a routerLink="#!">Event</a></li>
                                        <li><a routerLink="asbmc-labs">Labs</a></li>-->
                                        <li><a routerLink="asbmc-contactus">Contact us</a></li>

                                        <li><a routerLink="#1" class="heading">Arni School of Arts &
                                            Humanities</a></li>
                                        <li><a routerLink="asah">About us</a></li>
                                        <li><a routerLink="asah-syllabus">Syllabus</a></li>
                                        <li><a routerLink="">Department</a></li>

                                        <li><a routerLink="asah-english">English</a>
                                        </li>
                                        <li><a routerLink="asah-education">Education</a>
                                        </li>
                                        <li><a routerLink="asah-library-science">Library
                                            Science</a></li>
                                        <li><a
                                            routerLink="asah-journalism-and-mass-communication">Journalism
                                            & Mass Communication</a>
                                        </li>
                                        <li><a routerLink="asah-fashion-design">Design</a>
                                        </li>
                                        <li><a routerLink="asah-yoga-science">Yoga
                                            Science</a>
                                        </li>
                                        <li><a routerLink="asah-vocational-course">Vocational
                                            Courses</a></li>
                                        <!--<li><a routerLink="#!">Event</a></li>
                                        <li><a routerLink="asbmc-labs">Labs</a></li>-->
                                        <li><a routerLink="asbmc-contactus">Contact us</a></li>

                                        <li><a routerLink="#!" class="heading">Arni School of Basic
                                            Sciences &
                                            Bio-Technology</a></li>

                                        <li><a routerLink="asbsbt">About us</a></li>
                                        <li><a routerLink="asbsbt-syllabus">Syllabus</a></li>
                                        <li><a routerLink="">Department</a>
                                            <ul class="bg-primary inner-ul w-10">
                                                <li><a
                                                    routerLink="asbsbt-physical-science">Physics</a>
                                                </li>
                                                <li><a routerLink="asbsbt-life-science">Life
                                                    Science</a>
                                                </li>
                                                <li><a routerLink="asbsbt-chemistry">Chemistry</a>
                                                </li>
                                                <li><a
                                                    routerLink="asbsbt-maths">Maths</a>
                                                </li>
                                            </ul>
                                        </li>
                                        <!--<li><a routerLink="#!">Event</a></li>
                                        <li><a routerLink="asbmc-labs">Labs</a></li>-->
                                        <li><a routerLink="asbsbt-contact">Contact us</a></li>

                                        <li><a routerLink="#!" class="heading">Arni School of Allied
                                            Health
                                            Sciences</a>

                                        <li><a routerLink="asahs">About us</a></li>
                                        <li><a routerLink="asahs-syllabus">Syllabus</a></li>
                                        <li><a routerLink="">Department</a></li>

                                        <li><a routerLink="asahs-radiology">Radiology</a>
                                        </li>
                                        <li><a routerLink="asahs-ott">Operation Theatre
                                            Technology</a>
                                        </li>
                                        <li><a routerLink="asahs-anesthesia">Anesthesia</a>
                                        </li>
                                        <li><a routerLink="asahs-optometry">Optometry</a>
                                        </li>
                                        <li><a routerLink="asahs-mlt">MLT</a></li>
                                        <li><a
                                            routerLink="asahs-physiotherapy">Physiotherapy</a>
                                        </li>
                                        <li><a routerLink="asahs-yogasci">NYS</a></li>

                                        <!--<li><a routerLink="#!">Event</a></li>
                                        <li><a routerLink="asahs-lab">Labs</a></li>-->
                                        <li><a routerLink="asahs-contact">Contact us</a></li>

                                        <li><a href="javascript:void(0)" class="heading">
                                            Arni School of Pharmacy</a>
                                        <li><a routerLink="asp">About us</a></li>
                                        <li><a routerLink="asp-syllabus">Syllabus</a></li>
                                        <li><a href="javascript:void(0)">Department</a></li>
                                        <li><a routerLink="asp-pharmacy">Pharmacy</a>
                                        </li>
                                        <!--  <li><a href="javascript:void(0)">Event</a></li>
                                          <li><a routerLink="asa-lab">Labs</a></li>-->
                                        <li><a routerLink="asp-contact">Contact us</a></li>
                                        <li><a href="javascript:void(0)" class="heading">
                                            Arni School of Agriculture</a>
                                        <li><a routerLink="asa">About us</a></li>
                                        <li><a routerLink="asa-syllabus">Syllabus</a></li>
                                        <li><a href="javascript:void(0)">Department</a></li>
                                        <li><a routerLink="asa-agriculture">Agriculture</a>
                                        </li>
                                        <!--<li><a href="javascript:void(0)">Event</a></li>
                                        <li><a routerLink="asa-lab">Labs</a></li>-->
                                        <li><a routerLink="asa-contact">Contact us</a></li>
                                        <li><a href="javascript:void(0)" class="heading">Arni
                                            School of Law</a>
                                        <li><a routerLink="asl">About us</a></li>
                                        <li><a routerLink="asl-syllabus">Syllabus</a></li>
                                        <li><a routerLink="">Department</a></li>
                                        <li><a routerLink="asl-legal-studies">Legal
                                            Studies</a>
                                        </li>
                                        <!-- <li><a href="javascript:void(0)">Event</a></li>
                                         <li><a routerLink="asl-lab">Labs</a></li>-->
                                        <li><a routerLink="asl-contact">Contact us</a></li>
                                        <li><a href="javascript:void(0)" class="heading">
                                            Arni School of Hotel Management & Tourism</a>
                                        <li><a routerLink="ashmt">About us</a></li>
                                        <li><a routerLink="ashmt-syllabus">Syllabus</a></li>
                                        <li><a routerLink="">Department</a></li>
                                        <li>
                                            <a routerLink="ashmt-toursim-and-Hospitality-Management">
                                                Hotel & Tourism</a>
                                        </li>
                                        <!--<li><a href="javascript:void(0)">Event</a></li>
                                        <li><a routerLink="ashmt-lab">Labs</a></li>-->
                                        <li><a routerLink="ashmt-contact">Contact us</a></li>
                                        <li><a href="javascript:void(0)"
                                               class="heading">
                                            Arni School of Education & Sports</a>
                                        <li><a routerLink="ases">About us</a></li>
                                        <li><a routerLink="ases-syllabus">Syllabus</a></li>
                                        <li><a href="javascript:void(0)">Department</a></li>
                                        <li><a
                                            routerLink="ases-physical-application">Sports</a>
                                        </li>
                                        <!-- <li><a href="javascript:void(0)">Event</a></li>
                                         <li><a routerLink="ases-lab">Labs</a></li>-->
                                        <li><a routerLink="ases-contact">Contact us</a></li>
                                        <li><a href="javascript:void(0)" class="heading">Staff Detail</a></li>
                                        <li><a routerLink="faculty-information">Teaching</a>
                                        </li>
                                        <li><a routerLink="non-teaching-staff">Non Teaching</a></li>
                                        <li><a routerLink="/programmes"
                                               class="heading">Programmes</a></li>
                                        <li><a routerLink="/placement" class="heading">Placement</a>
                                        </li>
                                        <li><a routerLink="/student-info-detail"
                                               class="heading">Alumni</a>
                                        </li>
                                        <li><a routerLink="/infrastructure"
                                               class="heading">Infrastructure</a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="{{research ? 'active' : ''}}" (click)="research=!research">
                                    <a routerLink="#!">RESEARCH</a>
                                    <ul class="{{research? 'open' : ''}}"
                                        style="display:{{research?'block !important': 'none'}};"
                                        (click)="phoneViewMenuOpen=!phoneViewMenuOpen">
                                        <li><a routerLink="/research">Research</a></li>
                                        <li><a href="javascript:void(0)">Research Policy</a></li>
                                        <li><a routerLink="research-unit">Research Unit</a></li>
                                        <li><a href="javascript:void(0)">Project Unit</a></li>
                                        <li><a href="javascript:void(0)">Other Services</a></li>
                                        <li><a href="javascript:void(0)">BORS</a></li>
                                    </ul>
                                </li>
                                <li class="{{admission ? 'active' : ''}}" (click)="admission=!admission">
                                    <a routerLink="#!">ADMISSION</a>
                                    <ul class="{{admission? 'open' : ''}}"
                                        style="display:{{admission?'block !important': 'none'}};"
                                        (click)="phoneViewMenuOpen=!phoneViewMenuOpen">
                                        <li><a routerLink="/admission-offices">Admission Offices</a></li>
                                        <li><a routerLink="/brouchure">Download Brochure</a></li>
                                        <li><a routerLink="/admission-form">Admission Form</a></li>
                                        <li><a href="javascript:void(0)" class="heading">Scholarship</a></li>
                                        <li><a routerLink="scholarship">Scholarship</a></li>
                                        <li><a
                                            class="cursor-pointer"
                                            (click)="goTo('https://docs.google.com/forms/d/e/1FAIpQLSdxxio3X-aZm2D7M2M496XC9lu7UrxszbwUTvhKd00eLaFWdg/viewform')">Scholarship
                                            JKSSS</a></li>
                                        <li><a routerLink="acedamic-calendar">Academic Calendar</a></li>
                                        <li><a href="javascript:void(0)">Security & Discipline</a></li>
                                        <li><a routerLink="refund-policy">Refund Policy</a></li>
                                    </ul>
                                </li>
                                <li class="{{lifearni ? 'active' : ''}}" (click)="lifearni=!lifearni">
                                    <a routerLink="#!">LIFE@ARNI</a>
                                    <ul class="{{lifearni? 'open' : ''}}"
                                        style="display:{{lifearni?'block !important': 'none'}};"
                                        (click)="phoneViewMenuOpen=!phoneViewMenuOpen">
                                        <li><a href="javascript:void(0)" class="heading">ARNI INFRASTRUCTURE</a></li>
                                        <li><a routerLink="hostel-infrastructure">Infrastructure</a></li>
                                        <li><a routerLink="mess">Mess Facilities</a></li>
                                        <li><a routerLink="cafeteria">Cafeteria</a></li>
                                        <li><a routerLink="hostel-gallery">Hostel Gallery</a></li>
                                        <li><a href="javascript:void(0)" class="heading">TRANSPORT</a></li>
                                        <li><a routerLink="bus-facility">Bus Facility</a></li>
                                        <li><a href="javascript:void(0)" class="heading">LIBRARY</a></li>
                                        <li><a routerLink="library">Library</a></li>
                                        <li><a href="javascript:void(0)" class="heading">GALLERY</a></li>
                                        <li><a routerLink="video-gallery">Video Gallery</a></li>
                                        <li><a href="/media-gallery">Media Gallery</a>
                                        </li>
                                        <li><a routerLink="photo-gallery">Photo Gallery</a></li>
                                        <li><a href="javascript:void(0)" class="heading">GREEN CAMPUS</a></li>
                                        <li><a routerLink="green-campus">Green Campus Policy</a>
                                        </li>
                                        <li><a routerLink="/extra-curricullar-activities">Extracurricular
                                            Activities</a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="{{examination ? 'active' : ''}}" (click)="examination=!examination">
                                    <a routerLink="#!">EXAMINATION</a>
                                    <ul class="{{examination? 'open' : ''}}"
                                        style="display:{{examination?'block !important': 'none'}};"
                                        (click)="phoneViewMenuOpen=!phoneViewMenuOpen">
                                        <li><a class="cursor-pointer" (click)="goTo('https://student.arniu.in/')">Student
                                            Login</a></li>
                                        <li><a class="cursor-pointer"
                                               (click)="goTo('https://arni.in/Student/Studentlogin')">Result</a>
                                        </li>
                                        <li><a routerLink="/circular-notice">Circular Notice</a></li>
                                        <li><a routerLink="datesheet">Datesheet</a></li>
                                        <li><a routerLink="/online-education">Online Education</a></li>
                                        <li><a routerLink="/online-exam">Online Exam</a></li>
                                    </ul>
                                </li>
                                <li class="{{iqac ? 'active' : ''}}" (click)="iqac=!iqac">
                                    <a routerLink="#!">IQAC</a>
                                    <ul class="{{iqac? 'open' : ''}}"
                                        style="display:{{iqac?'block !important': 'none'}};"
                                        (click)="phoneViewMenuOpen=!phoneViewMenuOpen">
                                        <li><a routerLink="/iqac">IQAC</a></li>
                                        <li><a routerLink="/iqac-minutes">Minutes</a></li>
                                        <li><a routerLink="iqac">Feedback</a></li>
                                        <li><a routerLink="student-survey">Survey</a></li>
                                        <li><a routerLink="/initiative-reports">Initiative</a></li>
                                        <li><a routerLink="/induction-program">Induction</a></li>
                                        <li><a routerLink="/quality-mandates">Mandates</a></li>
                                        <li><a routerLink="/mooc">MOOC</a></li>
                                    </ul>
                                </li>
                                <li (click)="phoneViewMenuOpen=!phoneViewMenuOpen"><a class="cursor-pointer"
                                                                                      (click)="goTo('https://arni.in/2024/AdmHome.aspx')">Admin</a>
                                </li>
                                <li (click)="phoneViewMenuOpen=!phoneViewMenuOpen"><a class="cursor-pointer"
                                                                                      (click)="goTo('https://arni.in/2024/StuGR.aspx')">SGRC</a>
                                </li>
                            </ul>
                            <!-- end menu area -->
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>
